import { colors } from "../colors_v2.js";
import { identityService } from "../profile/identityService_v2.js";
import { utilsApp } from "../utils-app_v2.js";
import { matchService } from "./matchService_v2.js";
import { iPop } from "../ipop_v2.js";
import { eventHub } from "../eventHub_v2.js";
import { escapeHtml } from "../escapeHtml_v2.js";
import { scoreBoard } from "../scoreBoard/scoreBoard_v2.js";
import { board } from "../game/gameBoard_v2.js";
import { zoom } from "../zoom_v2.js";
import { profile } from "../profile/profile_v2.js";
import { router } from "../router_v2.js";
import { dasModal } from "../modal_v2.js";

var joinState = {
  size: "small",
};

// always in the dom
const joinNav = document.getElementById("joinNav");
const joinSection = document.getElementById("joinSection");

const getSize = () => {
  return joinState.size;
};

const renderjoinNav = () => {
  joinNav.classList.add("sectionNarrow");
};

const render = async (size) => {
  if (!utilsApp.isSizeValid(size)) {
    console.log("ERROR: Size is not valid");
    return;
  }
  const pAIdentityResponse = await identityService.getPlayingAs();
  if (pAIdentityResponse.status != 200) {
    // session expired
    return;
  }
  const pAIdentity = pAIdentityResponse.identity;
  renderjoinNav();
  switch (size) {
    case "normal":
      const modalBehinder = document.getElementById("modalBehinder");
      modalBehinder.style.display = "block";
      modalBehinder.dataset.action = "modalBehinderCloseJoin";
      joinState.size = "normal";
      joinSection.style.width = utilsApp.calculateSectionWidth();
      const htmlNormal = `
      <div class="flexRow width100" id="joinRow">
        <div id="sectionHeaderArea" class="vertical">
          <div class="menu">Join</div>
        </div>
        <div class="flexColumn width100 marginBottom30">
          <div><h3 class="center">Join a Match</h3>
          </div>
          <div class="joinContainer">
            <div id="joinLeftSide" class="joinGrouping">
              <div class="center font18">
                <div id="EnterMatchIdLabel">Enter the Code:<div id="joinSplainer" class="i">ⓘ</div><br>
                  <input id="joinCodeInput" placeholder="e.g. playsSecond-9ZQVXXY"></input>
                </div>
                <div class="courier" id="joinMessage"></div>
              </div>
            </div>
            <div id="joinRightSide" class="joinGrouping">
              <div id="joinButtonDiv">
                <button class="button" id="joinButton">Join</button>
              </div>
            </div>
          </div> 
        </div>
      </div>
      <div id="closejoinSection" class = "x"></div>
        `;
      joinSection.classList.add("sectionWide");
      joinSection.innerHTML = htmlNormal;
      document.getElementById("joinLeftSide").style.backgroundColor =
        colors.getGameColor("tip");
      colors.setButtonColors();
      const joinCodeInput = document.getElementById("joinCodeInput");
      joinCodeInput.style.backgroundColor =
        colors.getGameColor("lighterAccent");
      joinCodeInput.focus();
      const joinMessage = document.getElementById("joinMessage");
      const name = identityService.parseName(pAIdentity.name);
      const closejoinSection = document.getElementById("closejoinSection");
      utilsApp.adjust4Mobile();
      break;
    case "small":
      joinState.size = "small";
      joinSection.style.width = "0px";
      joinSection.innerHTML = "";
      joinSection.className = "";

      break;
    default:
      console.log("Error: Attempting to render join to invalid size: " + size);
      return;
  }
  setColorsAndListeners();
};

const renderJoinSplainer = (event) => {
  iPop.render({
    text: `
      <p>Enter the entire code, including the prefix:</p>
      <p>Join codes look like this (example only):
      <ul class="left">
        <li class="left">playsFirst-MXPV2PR</li class="left">
        <li class="left">playsSecond-VYBBE6F</li class="left">
        <li class="left">watcher-CCG9RUE</li class="left">
      </ul>
      `,
    event,
  });
};

const handleClose = () => {
  const modalBehinder = document.getElementById("modalBehinder");
  modalBehinder.style.display = "none";
  delete modalBehinder.dataset.action;
  render("small");
};

const setColorsAndListeners = () => {
  colors.setNavColors();
  joinSection.style.borderColor = colors.getGameColor("hexGrid");
  joinNav.style.borderColor = colors.getGameColor("hexGrid");
};

const handleJoin = async () => {
  const joinCode = document.getElementById("joinCodeInput").value.trim();
  const joinMessage = document.getElementById("joinMessage");
  const result = await matchService.join(joinCode);
  if (result.status != 200) {
    const keys = Object.keys(result);
    let msg = "Error";
    if (keys.includes("error")) {
      msg = result.error;
    }
    if (keys.includes("message")) {
      msg = result.message;
    }
    joinMessage.innerText = msg;
    return;
  }
  scoreBoard.render();
  board.render();
  utilsApp.makeNavsSmall();
};

const handlejoinNavClick = () => {
  switch (getSize()) {
    case "small":
      render("normal");
      break;
    case "normal":
      render("small");
      break;
    default:
      render("small");
  }
};

const joinByURL = async (urlJoinCode) => {
  router.clearURLJoinCode();
  const result = await matchService.join(urlJoinCode);
  if (result.status != 200) {
    const keys = Object.keys(result);
    let msg = "Error";
    if (keys.includes("error")) {
      msg = result.error;
    }
    if (keys.includes("message")) {
      msg = result.message;
    }
    dasModal.close();

    if (result?.errorType === "ALREADY_WATCHING") {
      dasModal.render(
        `<div class=max>Turns out you are already a watcher.</div>`,
      );
      await matchService.setCurrentMatchID(result?.matchToJoin);
      zoom.resizeCanvas();
      scoreBoard.render();
      board.render();
      profile.render("small");
      return { status: 200 };
    } else {
      dasModal.render(`<div class="max flexColumn">Join <span class="noWrap">Error<div id="joinErrorSplainer" class="i">ⓘ</div></span>
      <p>${escapeHtml(msg)}</p></div>`);
    }
    return { status: 400 };
  }
  await matchService.setCurrentMatchID(result.matchID);
  zoom.resizeCanvas();
  scoreBoard.render();
  board.render();
  profile.render("small");

  return { status: 200 };
};

const renderJoinErrorSplainer = (event) => {
  iPop.render({
    text: `
      <p>Did youeEnter the entire code, including the prefix?</p>
      `,
    event,
  });
};

eventHub.registerEvent("click", "modalBehinderCloseJoin", handleClose);
eventHub.registerEvent("click", "joinNav", handlejoinNavClick);
eventHub.registerEvent("click", "joinButton", handleJoin);
eventHub.registerEvent("click", "closejoinSection", handleClose);
eventHub.registerEvent("click", "joinSplainer", renderJoinSplainer);
eventHub.registerEvent("click", "joinErrorSplainer", renderJoinErrorSplainer);

export const join = {
  getSize,
  render,
  joinByURL,
};
